<template>
  <h1 class="login-header">Zresetuj swoje hasło</h1>
  <p class="login-description">
    Wprowadź swój login lub adres e-mail, aby zresetować hasło.
  </p>
  <div class="login-form-wrapper">
    <div class="login-form-wrapper__image-aside">
      <img src="@/assets/pies.png" alt="">
    </div>
    <div class="login-form-container">
      <Form @submit="handleReset" :validation-schema="resetSchema">
        <div class="form-group">
          <Field name="email" type="text" class="form-control" autocomplete="email" placeholder="Twój login/e-mail"/>
          <ErrorMessage name="email" class="error-feedback" />
        </div>
        <button :disabled="loading" class="submit-button">
          <span
            v-show="loading"
            class="spinner-border"
          ></span>
          <span>Wyślij e-mail z kodem</span>
        </button>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
    </div>
    <div class="login-form-wrapper__image-aside"></div>
  </div>
</template>
  
  <script>
  import { Form, Field, ErrorMessage } from "vee-validate";
  import * as yup from 'yup';
  import { useMeta } from 'vue-meta';
import axios from "axios";
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
//   import { RouterLink } from "vue-router";

  export default {
    name: "ResetPass",
    setup () {
        useMeta({
          title: 'Resetuj hasło',
          // meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
        })
    
    return {
        authStore: useAuthStore(),
        appStore: useAppStore(),
    }
  },
    components: {
      Form,
      Field,
      ErrorMessage,
    //   RouterLink
    },
    data() {
      const resetSchema = yup.object().shape({
        email: yup.string().required("login/e-mail jest wymagany!"),
      });
  
      return {
        loading: false,
        message: "",
        resetSchema,
        showPass: false
      };
    },
    computed: {
      loggedIn() {
        return this.authStore.loggedIn;
      },
    },
    created() {
        if (this.loggedIn) {
          let user = JSON.parse(localStorage.getItem('userm2VET'));
            if(user.data.role == 3){
                this.$router.push(`/profile`);
            }else if(user.data.role == 2){
                this.$router.push(`/dla-biznesu/profile`);
            }else if(user.data.role == 4){
              this.$router.push(`/dla-biznesu/employee-profile`)
            }else if(user.data.role == 1){
              this.$router.push(`/admin-profile`)
            }
      }
    },
    methods: {
        handleReset(user) {
          this.loading = true;
        axios.post('/RemindPassword', user).then(res => {
            if(String(res.status).charAt(0) == '2'){
                this.loading = false
                this.appStore.setResetPassEmail(user.email)
                setTimeout(() => {
                    this.$router.push('/login/reset2')
                },500)
            }
        }).catch(() => {
            this.appStore.setIsAlert('Nieprawidłowy adres e-mail')
            this.loading = false
        })
      },
    },
  };
  </script>

  <style lang="scss" scoped>
    .login-header{
        text-align: center;
        font-size: 3rem;
    }
    .login-description{
        text-align: center;
        margin-bottom: 20px;
    }
    .login-form-wrapper{
      display: flex;
      justify-content: center;
      gap: 80px;
      &__image-aside{
        width: 250px;
        img{
          width: 100%;
        }
      }
    }
    .login-form-container{
      flex: 2;
        form{
          width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            .form-group{
              width: 100%;
                display: flex;
                flex-direction: column;
              input{
                width: 100%;
                border: 1px solid #d1d5db;
                border-radius: 8px;
                padding: 12px 16px;
                background: #fff;
                color: #1f2937;
                font-size: 1.6rem;
                line-height: 1.4;
                transition: border-color .2s ease, box-shadow .2s ease;
                box-sizing: border-box;
              }
              input::placeholder{
                color: #9ca3af;
              }
              input:focus{
                outline: none;
                border-color: #10b981;
                box-shadow: 0 0 0 1px #10b981;
              }
                span{
                    font-size: 1.6rem;
                }
                span.show-hide-pass{
                  text-decoration: underline;
                  cursor: pointer;
                }
                a{
                  font-size: 1.6rem;
                  color: #000;
                }
                a.reset-pass{
                  margin-top: 10px;
                  text-decoration: none;
                }
            }
        }
    }

    button.submit-button{
      width: 100%;
      min-height: 46px;
      padding: 0 28px;
      border: none;
      border-radius: 8px;
      background: #10b981;
      color: #ffffff;
      font-size: 1.6rem;
      font-weight: 700;
      cursor: pointer;
      transition: background-color .2s ease, box-shadow .2s ease, transform .1s ease;
      box-shadow: 0 6px 16px rgba(16, 185, 129, .25);
    }
    button.submit-button:hover{
      background: #059669;
    }
    button.submit-button:focus{
      outline: none;
      box-shadow: 0 0 0 1px #10b981, 0 0 0 4px rgba(16, 185, 129, .2);
    }
    button.submit-button:active{
      transform: translateY(1px);
    }

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}

.spinner-border {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: text-bottom;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
  margin-right: 10px;
}

@media(max-width: 900px){
  .login-form-wrapper{
    &__image-aside{
      display: none;
    }
  }
}
</style>